/** Production site URL — override at build time via PUBLIC_SITE_URL. */
export const DEFAULT_SITE_URL = 'https://spotdove.com';

export const SITE_NAME = 'Spotdove';

export const SITE_TAGLINE = 'The easiest way to build pitch decks.';

export const DEFAULT_DESCRIPTION =
  'Spotdove helps founders create investor-ready pitch decks with industry templates, AI-assisted editing, and a beautiful slide editor — free to start.';

export const DEFAULT_OG_IMAGE_PATH = '/og-image.svg';

export const TWITTER_HANDLE = '@spotdove';

export const CONTACT_EMAILS = {
  legal: 'legal@spotdove.com',
  privacy: 'privacy@spotdove.com',
} as const;

/** Resolve the canonical origin (no trailing slash). */
export const getSiteUrl = (): string => {
  const fromEnv =
    typeof process !== 'undefined' && process.env.PUBLIC_SITE_URL
      ? process.env.PUBLIC_SITE_URL
      : '';

  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return DEFAULT_SITE_URL;
};

export const absoluteUrl = (path: string): string => {
  const base = getSiteUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
};

export const absoluteOgImageUrl = (): string => absoluteUrl(DEFAULT_OG_IMAGE_PATH);
